import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const Session_CrudSlice = createSlice({
  name: "Session_CrudSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    Session_Crud: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successSession_Crud: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureSession_Crud: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearSession_Crud: (state) => {
      state.data = {};
    },
  },
});

export const {
  Session_Crud,
  failureSession_Crud,
  successSession_Crud,
  clearSession_Crud,
} = Session_CrudSlice.actions;

export default Session_CrudSlice.reducer;
